import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SpesialTransportVeggruppeItem } from "../../RouteDescription/SpesialTransportVeggruppe";
import { RoadFeaturesWithBruksklasse } from "../../../services/RuteplanAPI";

export default function SpesialTransportVeggrupperListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  const roadFeatureResponse = props.roadFeatureResponse as RoadFeaturesWithBruksklasse;
  
  return(
    <>
    {roadFeatureResponse && roadFeatureResponse.spesialTransportVeggrupper && roadFeatureResponse.spesialTransportVeggrupper.length > 0 && (
      <>
        <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Veggrupper (${roadFeatureResponse.spesialTransportVeggrupper.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto" 
        unmountOnExit
        >
          <SpesialTransportVeggruppeItem roadFeatures={roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
      </>
    )}
    
    </>
  )
}